import cn from 'clsx'
import { Card } from '@/components/Card/Card'

import css from './TileCard.module.css'
import { type HyperLinkProps, HyperLink } from '@/components/hyper-link/hyper-link'

type TileCardProps = Omit<HyperLinkProps, 'size' | 'aria' | 'borderRadius' | 'weight'> & {
    icon?: React.ReactElement
}

function TileCard({ icon, className, children, disabled, ...rest }: TileCardProps) {
    return (
        <HyperLink
            size="minor-base"
            className={cn(css.tileCardContainer, { [css.disabled]: disabled }, className)}
            tabIndex={disabled ? -1 : 0}
            disabled={disabled}
            {...rest}
        >
            <Card className={css.tileCard}>
                {icon ? <span aria-hidden>{icon}</span> : null}
                <span className={css.textContainer}>{children}</span>
            </Card>
        </HyperLink>
    )
}

export { TileCard }
export type { TileCardProps }
